import { PayloadAction } from '@reduxjs/toolkit';
import { SchoolStoreType, SchoolType } from '../types';

export const setSchoolData = (state: SchoolStoreType, action: PayloadAction<SchoolType>) => {
  state.school = action.payload;
};
